import Script from 'next/script';

import { useConsentManager } from './consent-manager';

/**
 * Load the Mutiny analyticd script after airgap.js is initialized
 */
export const MutinyScript: React.FC = () => {
  const { airgap } = useConsentManager();

  return (
    <>
      {airgap && (
        <>
          {/* Mutiny client initialization script */}
          <Script
            id="mutiny-init"
            strategy="lazyOnload"
            dangerouslySetInnerHTML={{
              __html: `
                (function(){var a=window.mutiny=window.mutiny||{};if(!window.mutiny.client){a.client={_queue:{}};var b=["identify","trackConversion"];var c=[].concat(b,["defaultOptOut","optOut","optIn"]);var d=function factory(c){return function(){for(var d=arguments.length,e=new Array(d),f=0;f<d;f++){e[f]=arguments[f]}a.client._queue[c]=a.client._queue[c]||[];if(b.includes(c)){return new Promise(function(b,d){a.client._queue[c].push({args:e,resolve:b,reject:d})})}else{a.client._queue[c].push({args:e})}}};c.forEach(function(b){a.client[b]=d(b)})}})();
              `,
            }}
          />
          {/* Mutiny personalization client, we are not using personalisation on site right now */}
          {/* <Script
            src="https://client-registry.mutinycdn.com/personalize/client/158952fe614ed494.js"
            data-cfasync="false"
            strategy="afterInteractive"
          /> */}
        </>
      )}
    </>
  );
};
